import { render, staticRenderFns } from "./DDSignature.vue?vue&type=template&id=4226a039&scoped=true"
import script from "./DDSignature.vue?vue&type=script&lang=js"
export * from "./DDSignature.vue?vue&type=script&lang=js"
import style0 from "./DDSignature.vue?vue&type=style&index=0&id=4226a039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4226a039",
  null
  
)

export default component.exports